import React from 'react';
import propTypes from 'prop-types';

import { TranslatedMessage } from 'common/components/Intl';
import FlashMessages from 'common/containers/FlashMessages';
import { FORM_UNSUBSCRIBE } from '../messages';
import { ADDRESS_TYPE_SHIPPING } from '../appConstants';

import AddressForm from 'common/components/addresses/AddressForm';

const INITIAL_VALUES = {
  address1: '',
  city: '',
  first_name: '',
  last_name: '',
  state: '',
  zipcode: '',
};

const FIELD_PROPS = {
  company: {
    disabled: true,
  },
  phone: {
    hidden: true,
  },
};

export default class UnsubscribeAddressForm extends React.Component {
  static propTypes = {
    onSubmit: propTypes.func.isRequired,
  };

  handleAddressSubmit = address => {
    return this.props.onSubmit(address);
  };

  submitButtonText = () => {
    return <TranslatedMessage id={FORM_UNSUBSCRIBE} />;
  };

  render() {
    return (
      <div className="UnsubscribeAddressForm">
        <FlashMessages {...this.props} />
        <AddressForm
          initialValues={INITIAL_VALUES}
          addressType={ADDRESS_TYPE_SHIPPING}
          onSubmit={this.handleAddressSubmit}
          fieldProps={FIELD_PROPS}
          submitButtonText={this.submitButtonText()}
        />
      </div>
    );
  }
}
